import type { OrderEvent } from "../order-events/events/_order-event";
import type { OrderId } from "../order-id";

const firstEventMustBeAnOrderCreatedEventCheck = (
    orderId: OrderId,
    events: OrderEvent[],
) => {
    if (
        !(
            events[0]?.type === "CREATED" ||
            events[0].type === "CREATED_FROM_QUOTE"
        )
    ) {
        throw new Error(
            `The first event for an order must be ORDER_CREATED_EVENT; orderId: ${orderId}, eventCount: ${events.length}`,
        );
    }
};

export { firstEventMustBeAnOrderCreatedEventCheck };
